/*
 * @Author: mayanxia 
 * @Date: 2020-11-07 19:54:06 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2023-03-11 09:55:41
 */

<template>
  <a-modal
    :title="$t('操作')"
    :width="800"
    :ok=false
    :visible="visible"
    :confirmLoading="confirmLoading"
    :okButtonProps="{ props: {disabled: disableSubmit} }"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="$t('关闭')">

    <a-spin :spinning="confirmLoading">
        <a-divider orientation="left">{{ $t('用户信息') }}</a-divider>
        <detail-list>
            <detail-list-item :term="$t('表编号')">{{model.meterId}}</detail-list-item>
            <detail-list-item :term="$t('表类型')">{{model.meterTypeName}}</detail-list-item>
            <detail-list-item :term="$t('计费起始读数(m³)')">{{model.userMeterStartNum}}</detail-list-item>
            <detail-list-item :term="$t('运营商')">{{$t(netTypeObj[model.mtIotType])}}</detail-list-item>
            <detail-list-item :term="$t('IMEI号')">{{model.mtImei}}</detail-list-item>
            <detail-list-item :term="$t('SIM卡号')">{{model.mtSim}}</detail-list-item>
            <detail-list-item :term="$t('表安装地址')">{{model.userMeterAddr}}</detail-list-item>
            <detail-list-item :term="$t('用户编号')">{{model.userId}}</detail-list-item>
            <detail-list-item :term="$t('用户姓名')">{{model.userName}}</detail-list-item>
            <detail-list-item :term="$t('手机号码')">{{model.userPhone}}</detail-list-item>
            <detail-list-item :term="$t('身份证号')">{{model.userIdNumber}}</detail-list-item>
            <detail-list-item :term="$t('账户余额(元)')">{{model.userAccountNum?model.userAccountNum:'--'}}</detail-list-item>
        </detail-list>
        <a-divider orientation="left">{{ $t('旧价格信息') }}</a-divider>
        <detail-list :span="24">
            <detail-list-item :term="$t('价格编码')">{{priceInfo.wtCode}}</detail-list-item>
            <detail-list-item :term="$t('价格名称')">{{priceInfo.wtName}}</detail-list-item>
            <detail-list-item :term="$t('单价总计')">{{priceInfo.wtTotalPrice/100}}({{ $t('元/m³') }})</detail-list-item>
            <detail-list-item :term="$t('计费类型')">{{filterDictTextByCache('wt_fee_type',priceInfo.wtFeeType)}}</detail-list-item>
            <detail-list-item :term="$t('阶梯数量')">{{filterDictTextByCache('wt_step_num',priceInfo.wtStepNum)}}</detail-list-item>
            <detail-list-item :term="$t('附加费总计')">{{priceInfo.wtTotalChargePrice?priceInfo.wtTotalChargePrice/100:''}}({{ $t('元/m³') }})</detail-list-item>
        </detail-list>
        <a-form-model ref="formModal" :model="formModel" :rules="rules" :colon="false" >
            <a-row :gutter="24">
                <a-col :span="8">
                    <a-form-model-item :label="$t('价格信息')" prop="newPriceId">
                        <a-select v-model="formModel.newPriceId" :placeholder="$t('请选择用户价格名称')" @change="changeNewPrice"
                            :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}">
                            <a-select-option v-for="data in userPriceList" :key="data.id" :value="data.id">
                            <a-tooltip>
                                <template slot="title">
                                {{ $t('单价:') }}{{data.wtTotalPrice/100}}{{ $t('元') }}
                                </template>
                                {{data.wtName}}
                            </a-tooltip>
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                </a-col>
                <a-col :span="8">
                    <a-form-model-item :label="$t('启用日期')" prop="startDate">
                      <a-date-picker
                        dropdownClassName="j-date-picker"
                        :placeholder="$t('请选择启用日期')"
                        v-model="formModel.startDate"
                        :disabled-date="disabledDate"
                        :format="dateFormat"
                        />
                      <!--
                        <j-date placeholder="请选择启用日期" v-model="formModel.startDate" :trigger-change="true" style="width:100%"
                        />
                        -->
                    </a-form-model-item>
                </a-col>
                <a-col :span="8">
                    <a-form-model-item :label="$t('变更方式')" prop="changeWay">
                        <a-select  v-model="formModel.changeWay" :placeholder="$t('请选择')">
                            <a-select-option :value="1">
                            {{ $t('立即结算') }}
                            </a-select-option>
                            <a-select-option :value="2">
                            {{ $t('扣完再启用新价格') }}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                </a-col>
            </a-row>
        </a-form-model>
      <a-row v-if="!!formModel.newPriceId">
      <a-divider orientation="left">{{ $t('新价格信息') }}</a-divider>
        <detail-list :span="24">
            <detail-list-item :term="$t('价格编码')">{{newPriceInfo.wtCode}}</detail-list-item>
            <detail-list-item :term="$t('价格名称')">{{newPriceInfo.wtName}}</detail-list-item>
            <detail-list-item :term="$t('单价总计')">{{newPriceInfo.wtTotalPrice/100}}({{ $t('元/m³') }})</detail-list-item>
            <detail-list-item :term="$t('计费类型')">{{newPriceInfo.wtFeeType_dictText ? $t(newPriceInfo.wtFeeType_dictText) : newPriceInfo.wtFeeType_dictText}}</detail-list-item>
            <detail-list-item :term="$t('阶梯数量')">{{newPriceInfo.wtStepNum}}</detail-list-item>
            <detail-list-item :term="$t('附加费总计')">{{newPriceInfo.wtTotalChargePrice?newPriceInfo.wtTotalChargePrice/100:''}}({{ $t('元/m³') }})</detail-list-item>
        </detail-list>
      </a-row>
    </a-spin>
  </a-modal>
</template>

<script>
  import { postAction,getAction } from '@/api/manage'
  import {listSize,paramsToFormData } from '@/utils/util'
  import {netTypeObj} from '@/utils/constants/protocolConstant'
  import JDate from '@/components/jeecg/JDate'
  import moment from 'moment';
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  import { filterDictTextByCache } from '@/components/dict/JDictSelectUtil';
  export default {
    name: "MeterUserinfoChangePriceModal",
    components: {
        DetailList,
        DetailListItem,
        JDate
      },
    data () {
      return {
        netTypeObj,
        title:this.$t("操作"),
        visible: false,
        disableSubmit:false,
        model: {
        },
        formModel: {
            newPriceId: '',
            startDate: '',
            changeWay: '',
        },
        confirmLoading: false,
        url: {
          add: "/jeecg-charge/meter/meterPriceChangeRecord/doChangePriceTask",
          userPriceCode: "/jeecg-charge/meter/meterPriceinfo/list",
          queryById: "/jeecg-charge/meter/meterPriceinfo/queryById",
          userAccountList: "/jeecg-charge/meter/meterUserAccount/list"
        },
        priceInfo: {},
        newPriceInfo: {},
        userPriceList: [],
        dateFormat:"YYYY-MM-DD",
        filterDictTextByCache,
      }
    },
    created () {
    },
    computed: {
      // i18n：校验消息使用 computed 以响应语言切换
      rules() {
        return {
          newPriceId: [{required: true, message: this.$t('请选择价格信息!')}],
          startDate: [{required: true, message: this.$t('请选择价格启用日期!')}],
          changeWay: [{required: true, message: this.$t('请选择变更方式!')}],
        }
      },
    },
    methods: {
      moment,
      disabledDate(current) {
        // Can not select days before today and today
        //return current && current <= moment().endOf('day');

        // 只能选择今日及后边的日期
        return current && current < moment().subtract(1, 'days').endOf('day')
      },
      getUserPriceList() {
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        params.statusDisable = 0;
        getAction(this.url.userPriceCode, params).then((res) => {
          if(res.success){
            this.userPriceList = res.result.records;
          }
        })
      },
      add () {
        
        this.edit({});
      },
      edit (record) {
        this.formModel = this.$options.data.call(this).formModel
        this.model = Object.assign(this.model, record);
        this.visible = true;
        if(!!this.model.id) {
          this.getUserAccountByUserKeyId(this.model.id);
          this.getUserPriceById(this.model.userPriceCode);
        }
        
        this.getUserPriceList();
      },
      close () {
        this.$emit('close');
        this.disableSubmit = false;
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.$refs.formModal.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let formData = new FormData();
            
            let params ={...this.formModel};
            params.userKeyId = this.model.id;
            params.userId= this.model.userId;
            params.meterId = this.model.meterId;
            params.oldPriceId = this.model.userPriceCode;
            params.startDate = moment(this.formModel.startDate).format(this.dateFormat)
            formData = paramsToFormData(params);
            console.log(params)
            
            postAction(this.url.add,formData).then((res)=>{
              if(res.success&&res.code == 0){
                that.$message.success(res.message);
                setTimeout(() => {
                  that.$emit('ok');
                },400)
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
        })
      },
      handleCancel () {
        this.close()
      },
      getUserPriceById(id) {
        let params = {id: id}
        getAction(this.url.queryById, params).then((res) => {
          if(res.success){
            this.priceInfo = res.result||{};
          }else{
            this.priceInfo = {};
          }
        })
      },
      changeNewPrice(value) {
        console.log(value)
        this.newPriceInfo = {};
        if(value==''||value==undefined) {
          return;
        }
        this.newPriceInfo=this.userPriceList.find(item => item.id === value)
      },
      getUserAccountByUserKeyId(id) {
        let params = {userKeyId: id}
        params.pageNo = 1;
        params.pageSize = 1;
        getAction(this.url.userAccountList, params).then((res) => {
          if(res.success&&res.result.records.length>0){
            console.log(res.result.records[0].userAccountNum)
            this.model.userAccountNum = res.result.records[0].userAccountNum;
          }
        })
      },
    }
  }
</script>

<style scoped>
.detail-list >>> .content{
    line-height: normal;
}
</style>